import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {Player} from '../../shared/models/player';
import {SelectedPlayers} from '../models/player-filter';

export const defaultPlayerActionTypes = {
  DEFAULT: type('[Player] DEFAULT'),
  DEFAULT_SUCCESS: type('[Player] DEFAULT Success'),
  DEFAULT_FAIL: type('[Player] DEFAULT Fail'),
  DEFAULT_SELECTION_PLAYER: type('[Player] Default selected player'),
  SET_DEFAULT: type('[Player] SET DEFAULT'),
  SET_DEFAULT_FAIL: type('[Player] SET DEFAULT Fail')
};

export class DefaultPlayerAction implements Action {
  readonly type = defaultPlayerActionTypes.DEFAULT;
  constructor(public payload?: string ) {}
}

export class DefaultPlayerSuccessAction implements Action {
  readonly type = defaultPlayerActionTypes.DEFAULT_SUCCESS;
  constructor(public payload?: ArrayResponse<Player>) {}
}

export class DefaultPlayerFailAction implements Action {
  readonly type = defaultPlayerActionTypes.DEFAULT_FAIL;
  constructor(public payload?: string) {}
}

export class DefaultPlayerSelectionAction implements Action {
  readonly type = defaultPlayerActionTypes.DEFAULT_SELECTION_PLAYER;
  constructor(public payload?: SelectedPlayers) {}
}

export class SetDefaultPlayerAction implements Action {
  readonly type = defaultPlayerActionTypes.SET_DEFAULT;
  constructor(public payload?: string ) {}
}

export class SetDefaultPlayerFailAction implements Action {
  readonly type = defaultPlayerActionTypes.SET_DEFAULT_FAIL;
  constructor(public payload?: string) {}
}
